// Shared loading/error/empty state panels for reports.

import { Alert, Skeleton } from '@bbpos/ui';

export function ReportSkeleton({ kpiCount = 4 }: { kpiCount?: number }) {
  return (
    <>
      <div className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-${Math.min(kpiCount, 4)} gap-4 lg:gap-5 mb-6`}>
        {Array.from({ length: kpiCount }).map((_, i) => (
          <Skeleton key={i} variant="rect" height={120} className="rounded-xl" />
        ))}
      </div>
      <Skeleton variant="rect" height={280} className="rounded-2xl mb-6" />
      <div className="space-y-2">
        {Array.from({ length: 6 }).map((_, i) => (
          <Skeleton key={i} variant="rect" height={48} className="rounded-lg" />
        ))}
      </div>
    </>
  );
}

export function ReportError({ message }: { message?: string }) {
  return (
    <Alert
      variant="danger"
      title="Unable to load report"
      description={
        message ?? 'Something went wrong while fetching this report. Please refresh or try again shortly.'
      }
    />
  );
}
